import { services } from '../../../../../constants/services';
import { create } from '../../../../../utils/api';


export const CreateOrUpdateItemRolePermissionsService = async (itemRoleData: any): Promise<any> => {
    let newQrCode: any = '';
    newQrCode = await create(`${services.users}/access/item-role-permissions`, itemRoleData);
    return newQrCode;
};